import { OPM_TABLE_HEADER_ADDITIONAL_COL_COUNT } from '@app/shared/constants/table-config';
import { OpmInputsYearDto } from '@app/shared/models/contracts/opm-calculation-results-dto';

export const getMaxColumnCount = (
  historicYearCount: number,
  forecastYearCount: number,
  showHistoricDataColumns: boolean
) => {
  const historicCount = showHistoricDataColumns ? historicYearCount : 0;
  return historicCount + forecastYearCount + OPM_TABLE_HEADER_ADDITIONAL_COL_COUNT;
};

export const filterHistoricEventDatesFromFirstEvent = (
  historicEventDates: Record<string, OpmInputsYearDto>
): Record<string, OpmInputsYearDto> => {
  if (!historicEventDates) {
    return {};
  }

  const sortedDates = Object.keys(historicEventDates).sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime()
  );

  const firstDateWithMovement = sortedDates.find((date) => {
    const yearData = historicEventDates[date];
    return (
      Object.values(yearData.shareholderDebtInstrumentsEvents).some((instrument) =>
        instrument.periodByEvent.some(
          (event) =>
            event.additions !== 0 || event.accruedInterest !== 0 || event.cashPayInterest !== 0
        )
      ) ||
      Object.values(yearData.ordinaryInstruments).some((instrument) =>
        instrument.periodByEvent.some((event) => event.additions !== 0)
      )
    );
  });

  if (!firstDateWithMovement) {
    return {};
  }

  const firstDateTimestamp = new Date(firstDateWithMovement).getTime();

  return Object.fromEntries(
    sortedDates
      .filter((date) => new Date(date).getTime() >= firstDateTimestamp)
      .map((date) => [date, historicEventDates[date]])
  );
};
